/** @jsx jsx */
import React from 'react'
import { Box, jsx, Text, Textarea } from 'theme-ui'
import FormLabel from '~/components/Generic/Form/Label'

const FormTextarea = React.forwardRef(
  ({ error, label, name, required, ...props }, ref) => {
    return (
      <Box>
        <FormLabel name={name} label={label} required={required} />
        <Textarea
          sx={{
            variant: 'text.body2',
            backgroundColor: 'white',
            border: '1px solid',
            borderColor: 'greyMedium',
            borderRadius: 0,
            color: 'black',
            lineHeight: '28px',
            width: '100%',
            padding: '11px 14px',
          }}
          name={name}
          ref={ref}
          {...props}
        />
        {error && (
          <Text as="p" mt={1} variant="error">
            {error}
          </Text>
        )}
      </Box>
    )
  }
)
export default FormTextarea
